<template>
  <PopoverMenu @hide="onPopoverHide">
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #items-list>
      <PopoverMenuSection>
        <PopoverMenuSection class="multi-select__header-grid" :divider-bottom="!search">
          <slot name="label" />
          <CheckBoxToggle
            :id="id"
            :checked="isAllSelected"
            :indeterminate="isIndeterminate"
            @update:checked="toggleAll"
            position="end"
          />
        </PopoverMenuSection>
        <PopoverMenuSection v-if="search" divider-bottom>
          <InputBox focus-on-mount v-model="searchTerm" placeholder="Search">
            <template #icon>
              <SearchIcon16 />
            </template>
          </InputBox>
        </PopoverMenuSection>
        <PopoverMenuSelectionList
          :options="options.filter(({ label }) => label.toLowerCase().includes(searchTerm.toLowerCase()))"
          :modelValue="modelValue"
          @update:modelValue="$emit('change', $event)"
          multi
        />
      </PopoverMenuSection>
    </template>
  </PopoverMenu>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import PopoverMenuSection from '@components/common/PopoverMenu/PopoverMenuSection.vue';
import SearchIcon16 from '@components/Icons/SearchIcon16.vue';
import InputBox from '@components/common/InputBox.vue';

import { ListOptions } from '@components/common/SelectionList.vue';
import CheckBoxToggle from '@components/common/CheckBoxToggle.vue';
import { pseudoRandomId } from '@utils/pseudoRandomId';

export default defineComponent({
  name: 'MultiSelectPopover',
  emits: { change: null },
  components: { CheckBoxToggle, InputBox, SearchIcon16, PopoverMenuSection },
  props: {
    options: {
      type: Array as PropType<ListOptions>,
      required: true,
    },
    modelValue: {
      required: true,
      type: Array,
    },
    search: {
      type: Boolean,
      default: false,
    },
  },
  data(): {
    searchTerm: string;
    id: string;
  } {
    return {
      id: pseudoRandomId(),
      searchTerm: '',
    };
  },
  computed: {
    isAllSelected(): boolean {
      return this.options.every(({ value }) => this.modelValue.includes(value));
    },
    isIndeterminate(): boolean {
      return !this.isAllSelected && this.modelValue.length > 0;
    },
  },
  methods: {
    onPopoverHide() {
      this.searchTerm = '';
    },
    toggleAll() {
      const newValue = this.isAllSelected ? [] : this.options.map(({ value }) => value);
      this.$emit('change', newValue);
    },
  },
});
</script>

<style lang="scss">
.multi-select__header-grid {
  display: grid;
  grid-template-columns: 1fr 28px;
  align-items: center;
}
</style>
